import { mapGetters, mapActions } from "vuex";

const BANNER_COURSE_ID = 1052;

export default {
	name	: "marathon-banner",
	props	: ['current'],
	data() {
		return {
			show : false
		};
	},
	computed: {
		...mapGetters({}),
	},
	async created() {
		if(this.current && this.current.id == BANNER_COURSE_ID){
			this.show = true;
		}else{
			this.show = false;
		}
	},
	methods: {
		...mapActions({}),
	},
	watch: {
		current	: function() {
			if(this.current && this.current.id == BANNER_COURSE_ID){
				this.show = true;
			}else{
				this.show = false;
			}
		},
	},
};
